import $ from 'jquery';
(function(){
    'use strict';
    let $errors = $('.ee-form').find('.sq-form-error');
    // eslint-disable-next-line no-unused-vars
    $errors.each( function (index) {
        $(this).siblings('.sq-form-question-answer').find('input').addClass('error-input');
        $(this).siblings('.sq-form-question-answer').find('select').addClass('error-input');
        $(this).siblings('.sq-form-question-answer').find('textarea').addClass('error-input');
    })    
}());
